import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {Centre} from "../../../../interfaces/Centres";
import {Observable} from "rxjs";
import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {FullChild} from "../../../../interfaces/FullChild";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatSelect, MatSelectChange} from "@angular/material/select";
import {CentreService} from "../../../../services/centre.service";
import {EducationService} from "../../education.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AddGroupEducationComponent} from "../add-group-education/add-group-education.component";
import {ChildService} from "../../../../components/child/child.service";
import {CentreSelection} from "../../../counseling/components/add-group-session/add-group-session.component";
import {MatOption} from "@angular/material/core";
import firebase from "firebase/compat";
import Timestamp = firebase.firestore.Timestamp;
import {LogService} from "../../../../services/log.service";
import {cloneDeep, isEqual} from "lodash";
import {AngularFireDatabase} from "@angular/fire/compat/database";

@Component({
  selector: 'app-edit-group-education',
  templateUrl: './edit-group-education.component.html',
  styleUrls: ['./edit-group-education.component.scss']
})
export class EditGroupEducationComponent implements OnInit {
  centres$: Observable<Centre[]>
  docpath = 'educationGroupTest/'
  dbType: any = 'firestore'
  formSaved = false
  allSelected = false;
  showVolunteerName = false
  mVolunteers$:Observable<any>

  userData = JSON.parse(localStorage.getItem('userData')!)
  storagePath = 'EducationDocs'
  children$?: Observable<FullChild[]>
  selectedCentreCode!: string
  allChildrens?: any[]
  selectedCentreName!: string
  startTimeValue: any
  endTimeValue: any
  form!: FormGroup
  centreSelect: FormControl = new FormControl('', Validators.required)
  childSelect: FormControl = new FormControl('', Validators.required)
  childrensArr: any[] = []
  selectedChildrens: any[] = []
  displayedColumns: String[] = ['childName', 'centreName', 'Action'];
  initialFormState: any; //?add this



  @ViewChild('select') select?: MatSelect;

  constructor(readonly centreService: CentreService,
              readonly eduationService: EducationService,
              readonly matSnackBar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) public data: any,
              readonly matDialogRef: MatDialogRef<EditGroupEducationComponent>,
              readonly childService: ChildService,
              private readonly  mDatabase: AngularFireDatabase,

  private readonly mLogService:LogService,
  ) {
    this.centres$ = centreService.getAllCentres()
    this.mVolunteers$ =  this.mDatabase.list('types/Volunteers').valueChanges()

  }

  ngOnInit(): void {
    this.initForm()
    this.initialFormState = cloneDeep(this.form); //?add this

  }

  private initForm() {
    this.selectedChildrens = this.data.children

    this.form = new FormGroup({
      centres: new FormControl(this.getCentresName(this.data.centres), Validators.required),
      children: new FormControl(this.selectedChildrens, Validators.required),
      sessionType: new FormControl(this.data.sessionType, Validators.required),
      sessionDate: new FormControl((this.data.sessionDate as Timestamp).toDate(), Validators.required),
      topicsCovered: new FormControl(this.data.topicsCovered, Validators.required),
      sessionDetails: new FormControl(this.data.sessionDetails, Validators.required),
      remark: new FormControl(this.data.remark, Validators.required),
      subject: new FormControl(this.data.subject, Validators.required),
      // present: new FormControl('', Validators.required),
      startTime: new FormControl((this.data.startTime as Timestamp).toDate(), Validators.required),
      volunteerName: new FormControl(this.data.volunteerName),
      endTime: new FormControl((this.data.endTime as Timestamp).toDate(), Validators.required),
      updateBy: new FormControl({value: this.userData.userName, disabled: true}, Validators.required),
      createdAt: new FormControl((this.data.createdAt as Timestamp).toDate()),
      countType: new FormControl(this.data.countType ),
      updatedAt: new FormControl(new Date()),
      // absentReason: new FormControl('', absentConditionallyRequiredValidator)
    })
    this.form.get('centres')?.disable()
  }

  onCentreSelect($event: any) {
    this.selectedCentreCode = $event.value.centreCode
    this.selectedCentreName = $event.value.centreName
    this.children$ = this.childService.getAllotedChildListByCenterAboveThree(this.selectedCentreCode)
    this.children$.subscribe(res => {
      this.selectedChildrens = res
      this.allChildrens = res
    })

    this.CenterName?.setValue($event.value.centreName)
    this.CentreCode?.setValue(this.selectedCentreCode)
  }


  get startTime() {
    return this.form.get('startTime')
  }
  OnConductedByChange($event: MatSelectChange) {
    if ($event.value === 'By Teacher') {
      this.showVolunteerName = false;
      this.form.get('volunteerName')?.setValue('')
    } else if ($event.value === 'By Volunteer') {
      this.showVolunteerName = true;
    }
  }
  get ChildUnit() {
    return this.form.get('unitCode')
  }

  get endTime() {
    return this.form.get('endTime')
  }

  get ChildGender() {
    return this.form.get('gender')
  }

  get ChildName() {
    return this.form.get('childName')
  }

  get ChildCode() {
    return this.form.get('childCode')
  }

  get CenterName() {
    return this.form.get('centreName')
  }

  get CentreCode() {
    return this.form.get('centreCode')
  }

  //* Invokes when centre is created
  fetchChildren($event: MatSelectChange) {
    this.allSelected =true
    let centres = $event.value as CentreSelection[]
    let centreCodes: String[] = []
    let centreNames: String[] = []
    let allcentres: any[] = []
    centres.forEach(v => {
      centreCodes.push(v.centreCode)
      centreNames.push(v.centreName)
      allcentres.push({
        centreName: v.centreName,
        centreCode: v.centreCode
      })
    })

    console.log(centreCodes)
    console.log(centreNames)
    // alert(centre)
    this.data.children.forEach((it: { childCode: any; gender: any; selectUnit: any; firstName: string; lastName: string; status: any;isFollowUp:string })=>{
        this.selectedChildrens.push({
          'childCode': it.childCode,
          'gender': it.gender,
          'unitCode': it.selectUnit,
          'childName': it.firstName + ' ' + it.lastName,
          "status": it.status,
          "isFollowUp": it.isFollowUp

    })
    })
    this.form.get('centres')?.setValue(allcentres)

  }

  onChildSelect($event: MatSelectChange) {
    let children = $event.value as FullChild[]
    let childrens: any[] = []
    let childNames: String[] = []
    children.forEach(v => {
      childrens.push({
        'childCode': v.childCode,
        'gender': v.gender,
        'unitCode': v.selectUnit,
        'childName': v.firstName + ' ' + v.lastName,
        "status": "Present",
        "isFollowUp": "No"
      })
      childNames.push(v.firstName + " " + v.lastName)
      // let p = (v.guardians[0]?.firstName +' and '+v.guardians[1]?.firstName).toString()
      // console.log('p',p)
      // this.parents?.push(p)
      // console.log(this.parents)
    })

    // this.form.get('childCodes')?.setValue(childCodes)
    // this.form.get('childNames')?.setValue(childNames)
    this.form.get('children')?.setValue(childrens)
    // @ts-ignore
    this.selectedChildrens = childrens
    this.form.get('children')?.setValue(this.selectedChildrens)
  }

  Submit() {
    this.form.get('children')?.setValue(this.selectedChildrens)
    const submittedFormState: any = this.form; //?add this



    if (this.form.valid) {
      this.form.removeControl('centres')
      console.log(this.form)
      this.eduationService.editGroupEducationSession(this.form.getRawValue(),this.data.id).then(res => {
        this.matSnackBar.open('Updated  Successfully')._dismissAfter(3000)
        const differences = this.getFormDifference(this.initialFormState, submittedFormState)

        let activity={
          date:new Date().getTime(),
          section: 'Group Education',
          action: 'Update',
          changes: differences,  //?add this
          description: `Session updated in Education by` ,
          currentIp: localStorage.getItem('currentip')!
        }
        this.mLogService.addLog(activity)
        this.close()
      })
    } else {
      this.matSnackBar.open('Please these fields :  ' + this.findInvalidControls())._dismissAfter(3000)
      this.close()
    }
  }

  getFormDifference(initialFormState: any, submittedFormState: any) {
    const differences: any = {};
try {
  for (const key in this.initialFormState.controls) {
    const initialControl = this.initialFormState.get(key);
    const submittedControl = submittedFormState.get(key);
    console.log(`Initial Value: ${initialControl.value}`);
    // console.log(`Submitted Value: ${submittedControl.value}`);
    if (initialControl instanceof FormArray && submittedControl instanceof FormArray) {

      // Handle FormArray fields
      for (let i = 0; i < initialControl.length; i++) {
        if (!isEqual(initialControl.at(i).value, submittedControl.at(i).value)) {

          if (!differences[key]) {

            differences[key] = [];
          }
          alert('differnce found')

          differences[key].push({
            index: i,
            initialValue: initialControl.at(i).value,
            submittedValue: submittedControl.at(i).value,
          });
        }
      }
    } else if (!isEqual(initialControl.value, submittedControl.value)) {
      // Handle regular FormControl fields
      alert('differnce found')
      alert(`${initialControl.value}=> ${submittedControl.value}`)
      differences[key] = {
        initialValue: initialControl.value,
        submittedValue: submittedControl.value,
      };
    }

  }
}
catch (e) {
  console.log(e)
}


    return differences
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  AddPresent(id: any, value: any, element1: any) {
    element1['status'] = value
  }

  isFollowUpChild(id: any, value: any, element1: any) {
    element1['isFollowUp'] = value
  }

  close() {
    this.matDialogRef.close()
  }



  optionClick() {
    let newStatus = true;
    this.select?.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.allSelected = newStatus;
  }

  toggleAllSelection() {
    if (this.allSelected) {
      this.select?.options.forEach((item: MatOption) => item.select());
    } else {
      this.select?.options.forEach((item: MatOption) => item.deselect());
    }
  }

  removeChild(index: number, c: any) {
    this.selectedChildrens = this.selectedChildrens.filter((c,i)=>i!=index)

  }

  private getCentresName(centres: { centreName: string; }[]) {
let centresName=''
   centres.forEach((it: { centreName: string; })=>{
     centresName += it.centreName+''
   })
    return centresName;
  }
}
